var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniversityGeneralAppdeadline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43.378,
    height: 43.378,
    viewBox: "0 0 43.378 43.378",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2259",
    d: "M0-682.665H43.378v43.378H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48163",
    "data-name": "Group 48163",
    transform: "translate(-1204 -1436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48347",
    "data-name": "Group 48347"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2255",
    transform: "translate(1204 1436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2257",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2263",
    transform: "translate(6.612 0.635)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2265",
    d: "M-341.017,0h-23.139V9.55a9.9,9.9,0,0,0,4.476,8.284l4.261,2.7a.616.616,0,0,1,0,1.041l-4.261,2.7a9.9,9.9,0,0,0-4.476,8.284v9.55h23.139v-9.55a9.9,9.9,0,0,0-4.476-8.284l-4.261-2.7a.616.616,0,0,1,0-1.041l4.261-2.7a9.9,9.9,0,0,0,4.476-8.284Z",
    transform: "translate(364.156)",
    fill: "#dff9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2267",
    transform: "translate(17.566 0.635)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2269",
    d: "M-50.819-302.609l4.261-2.7a9.9,9.9,0,0,0,4.476-8.284v-9.55h-4.646v9.55a9.9,9.9,0,0,1-4.476,8.284l-1.983,1.256a2.324,2.324,0,0,0,0,3.926l1.983,1.256a9.9,9.9,0,0,1,4.476,8.284v9.55h4.646v-9.55a9.9,9.9,0,0,0-4.476-8.284l-4.261-2.7a.616.616,0,0,1,0-1.041",
    transform: "translate(54.267 323.142)",
    fill: "#aee0d9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path2271",
    d: "M104.052-123.744h23.139v-7.718H104.052Z",
    transform: "translate(-97.44 166.487)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2273",
    transform: "translate(4.634 0.635)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2275",
    d: "M-384.783-54.347h-25.124a.985.985,0,0,1-.985-.985v-1.717a.985.985,0,0,1,.985-.985h25.124a.985.985,0,0,1,.985.985v1.717a.985.985,0,0,1-.985.985",
    transform: "translate(410.892 58.035)",
    fill: "#63c5b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2277",
    transform: "translate(27.106 0.635)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2279",
    d: "M-53.6,0h-3.637V3.688H-53.6a.985.985,0,0,0,.985-.985V.985A.985.985,0,0,0-53.6,0",
    transform: "translate(57.239)",
    fill: "#387f75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2281",
    transform: "translate(4.634 39.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2283",
    d: "M-384.783-54.347h-25.124a.985.985,0,0,1-.985-.985v-1.717a.985.985,0,0,1,.985-.985h25.124a.985.985,0,0,1,.985.985v1.717a.985.985,0,0,1-.985.985",
    transform: "translate(410.892 58.035)",
    fill: "#63c5b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2285",
    transform: "translate(6.714 11.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2287",
    d: "M0,0A9.9,9.9,0,0,0,4.373,6.869l4.261,2.7a.611.611,0,0,1,.286.519h5.093a.611.611,0,0,1,.286-.519l4.261-2.7A9.9,9.9,0,0,0,22.934,0Z",
    fill: "#63c5b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2289",
    transform: "translate(17.566 11.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2291",
    d: "M-46.6-148.659a.611.611,0,0,1,.286-.519l4.261-2.7a9.9,9.9,0,0,0,4.373-6.869h-4.646a9.9,9.9,0,0,1-4.373,6.869l-1.983,1.256a2.305,2.305,0,0,0-1.08,1.961Z",
    transform: "translate(49.761 158.746)",
    fill: "#387f75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2293",
    transform: "translate(22.379 26.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2295",
    d: "M-241.175-120.588a8.182,8.182,0,0,1-8.182,8.182,8.182,8.182,0,0,1-8.182-8.182,8.182,8.182,0,0,1,8.182-8.182,8.182,8.182,0,0,1,8.182,8.182",
    transform: "translate(257.539 128.77)",
    fill: "#aee0d9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2297",
    transform: "translate(28.239 26.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2299",
    d: "M-34.233,0a8.183,8.183,0,0,0-2.323.335A8.186,8.186,0,0,1-30.7,8.182a8.185,8.185,0,0,1-5.86,7.847,8.183,8.183,0,0,0,2.323.335,8.182,8.182,0,0,0,8.182-8.182A8.182,8.182,0,0,0-34.233,0",
    transform: "translate(36.556)",
    fill: "#387f75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2301",
    transform: "translate(24.655 28.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2303",
    d: "M-174.108-87.054a5.907,5.907,0,0,1-5.907,5.907,5.907,5.907,0,0,1-5.907-5.907,5.907,5.907,0,0,1,5.907-5.907,5.907,5.907,0,0,1,5.907,5.907",
    transform: "translate(185.922 92.961)",
    fill: "#fafaff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2305",
    transform: "translate(28.239 28.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2307",
    d: "M-34.233,0a5.888,5.888,0,0,0-2.323.475,5.908,5.908,0,0,1,3.584,5.432,5.908,5.908,0,0,1-3.584,5.432,5.886,5.886,0,0,0,2.323.475,5.907,5.907,0,0,0,5.907-5.907A5.907,5.907,0,0,0-34.233,0",
    transform: "translate(36.556)",
    fill: "#dff9ff"
  })))), /*#__PURE__*/React.createElement("text", {
    id: "text2311",
    transform: "translate(1234 1473)",
    fill: "#387f75",
    fontSize: 8,
    fontFamily: "Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "!"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityGeneralAppdeadline);
export default __webpack_public_path__ + "static/media/university-general-appdeadline.078e10bf93102cfc0891f4eab99005a7.svg";
export { ForwardRef as ReactComponent };